import React, { useEffect }             from 'react';
import { Observe }                      from 'rewire-core';
import Grid                             from '../ui/Grid';
import { defaultFontSizes }             from './TimecardGrids';
import AccordionView, { useGridStyles } from './AccordionView';
import { OtherPaymentsModelBase }       from './OtherPaymentsModel';

interface IOtherPaymentsProps {
  model: OtherPaymentsModelBase;
}

const OtherPaymentsView = (props: IOtherPaymentsProps) => {
  useEffect(() => () => props.model.reset(), []);
  const styles = useGridStyles(props);

  return (
    <AccordionView model={props.model} title='Other Payments'>
      <Observe render={() => {
        return <Grid grid={props.model.grid} className={styles.grid} gridFontSizes={defaultFontSizes} />;
       }} />
    </AccordionView>
  );
};

export default OtherPaymentsView;
